import { FunctionComponent } from 'react'
import styles from './planningKPI.module.scss'
import { CalendarEventType } from '@/types/Calendar.ts'
import Indicator from '@/components/_custom/Indicator/indicator.tsx'
import { useTranslation } from 'react-i18next'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { PlanningTabId } from '@/hooks/usePlanningRights.ts'

interface RegularKPIProps {
    planningActiveTab: PlanningTabId
    filterEvents: (filters: string[]) => void
    regularRequest: number
    regularSlot: number
    absence: number
    isParent: boolean
}

const RegularKPI: FunctionComponent<RegularKPIProps> = ({
    planningActiveTab,
    filterEvents,
    regularRequest,
    regularSlot,
    absence,
    isParent
}: RegularKPIProps) => {
    const { t } = useTranslation()

    const navigate: NavigateFunction = useNavigate()

    return (
        <>
            {regularRequest > 0 && (
                <a
                    className={styles.IndicatorClickable}
                    href={`/request?type=regular&tab=${planningActiveTab}`}
                    onClick={(e) => {
                        if (!(e.ctrlKey || e.metaKey)) {
                            e.preventDefault()
                            navigate(`/request?type=regular&tab=${planningActiveTab}`)
                        }
                    }}
                >
                    <Indicator
                        count={regularRequest}
                        parent={isParent}
                        size={'m'}
                        text={regularRequest > 1 ? t('regularRequestsWaiting') : t('regularRequestWaiting')}
                        className={styles.Indicator}
                        badge={'regularRequest'}
                    />
                </a>
            )}
            <a className={styles.IndicatorClickable} onClick={() => filterEvents([CalendarEventType.REGULAR])}>
                <Indicator
                    count={regularSlot}
                    parent={isParent}
                    size={'m'}
                    text={regularSlot > 1 ? t('regularSlots') : t('regularSlot')}
                    className={styles.Indicator}
                    badge={'regular'}
                />
            </a>
            <a className={styles.IndicatorClickable} onClick={() => filterEvents([CalendarEventType.ABSENCE])}>
                <Indicator
                    count={absence}
                    parent={isParent}
                    size={'m'}
                    text={absence > 1 ? t('absences') : t('absence')}
                    className={styles.Indicator}
                    badge={'absence'}
                />
            </a>
        </>
    )
}

export default RegularKPI
